

// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
//   const [isMobile, setIsMobile] = useState(false);

//   // Screen size check for responsiveness
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768); // Mobile/Tablet check
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Basic Calculations
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const startItem = ((currentPage - 1) * itemsPerPage) + 1;
//   const endItem = Math.min(currentPage * itemsPerPage, totalItems);

//   const getPageNumbers = () => {
//     const pages = [];
//     const showMax = isMobile ? 1 : 2; 

//     if (totalPages <= (isMobile ? 5 : 7)) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       pages.push(1);
//       if (currentPage > (isMobile ? 3 : 4)) pages.push('...');

//       let start = Math.max(2, currentPage - showMax);
//       let end = Math.min(totalPages - 1, currentPage + showMax);

//       if (isMobile) {
//         if (currentPage <= 3) end = 3;
//         if (currentPage >= totalPages - 2) start = totalPages - 2;
//       }

//       for (let i = start; i <= end; i++) {
//         if (!pages.includes(i)) pages.push(i);
//       }

//       if (currentPage < (isMobile ? totalPages - 2 : totalPages - 3)) pages.push('...');
//       if (!pages.includes(totalPages)) pages.push(totalPages);
//     }
//     return pages;
//   };

//   if (totalItems === 0) return null;

//   return (
//     <div className="w-full flex flex-col md:flex-row items-center justify-between gap-4 select-none">
      
//       {/* 1. Range Description (X - Y of Z) */}
//       <div className="text-[11px] sm:text-xs font-bold text-gray-400 uppercase tracking-widest">
//         Showing <span className="text-gray-700">{startItem}</span> - <span className="text-gray-700">{endItem}</span> of <span className="text-gray-700">{totalItems}</span>
//       </div>

//       {/* 2. Professional Pagination Numbers */}
//       <div className="flex items-center gap-1 sm:gap-2">
//         {/* Previous Arrow */}
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="p-1.5 sm:p-2 rounded-lg text-gray-400 hover:bg-gray-100 disabled:opacity-20 transition-colors flex-shrink-0"
//         >
//           <ChevronLeft size={isMobile ? 18 : 20} />
//         </button>

//         {/* Numbers Row */}
//         <div className="flex items-center gap-0.5 sm:gap-1">
//           {getPageNumbers().map((page, index) => (
//             <React.Fragment key={index}>
//               {page === '...' ? (
//                 <span className="w-6 sm:w-8 text-center text-gray-400 text-[10px] sm:text-xs font-bold">
//                   ...
//                 </span>
//               ) : (
//                 <button
//                   onClick={() => onPageChange(page)}
//                   className={`min-w-[30px] h-8 sm:min-w-[36px] sm:h-9 flex items-center justify-center rounded-lg text-[11px] sm:text-xs font-bold transition-all duration-200 ${
//                     currentPage === page
//                       ? 'bg-blue-600 text-white shadow-md shadow-blue-200 scale-105'
//                       : 'text-gray-600 hover:bg-gray-100'
//                   }`}
//                 >
//                   {page}
//                 </button>
//               )}
//             </React.Fragment>
//           ))}
//         </div>

//         {/* Next Arrow */}
//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="p-1.5 sm:p-2 rounded-lg text-gray-400 hover:bg-gray-100 disabled:opacity-20 transition-colors flex-shrink-0"
//         >
//           <ChevronRight size={isMobile ? 18 : 20} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Pagination;

// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 640);
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
//   const endItem = Math.min(currentPage * itemsPerPage, totalItems);

//   const getPageNumbers = () => {
//     const pages = [];
    
//     if (totalPages <= 5) {
//       // Total pages kammiya irundha ella numbers-um kaatuvom
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       // Logic: 1 ... [Prev] [Current] [Next] ... Last

//       pages.push(1); // Eppovum 1st page irukanum

//       if (currentPage > 3) {
//         pages.push('...'); // Left ellipsis
//       }

//       // Middle numbers calculation
//       let start = Math.max(2, currentPage - 1);
//       let end = Math.min(totalPages - 1, currentPage + 1);

//       // Boundary case: Page 1-la irukum podhu (1, 2, 3 theriyanum)
//       if (currentPage === 1) end = 3;
//       // Boundary case: Last page-la irukum podhu (Last-2, Last-1, Last theriyanum)
//       if (currentPage === totalPages) start = totalPages - 2;

//       for (let i = start; i <= end; i++) {
//         if (!pages.includes(i)) pages.push(i);
//       }

//       if (currentPage < totalPages - 2) {
//         pages.push('...'); // Right ellipsis
//       }

//       if (!pages.includes(totalPages)) {
//         pages.push(totalPages); // Eppovum Last page irukanum
//       }
//     }
//     return pages;
//   };

//   if (totalItems === 0) return null;

//   return (
//     <div className="w-full flex flex-col md:flex-row md:justify-between items-center gap-4 select-none">
      
//       {/* 1. Range Info Section */}
//       <div className="text-[10px] sm:text-[11px] font-bold text-gray-400 uppercase tracking-[0.15em]">
//         Showing <span className="text-gray-800 font-extrabold">{startItem}</span> - <span className="text-gray-800 font-extrabold">{endItem}</span> of <span className="text-gray-800 font-extrabold">{totalItems}</span>
//       </div>

//       {/* 2. Dynamic Pagination Section */}
//       <div className="flex items-center gap-1 sm:gap-2">
//         {/* Previous Button */}
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="p-2 rounded-xl text-gray-400 hover:bg-gray-100 disabled:opacity-20 transition-all active:scale-90 flex-shrink-0"
//         >
//           <ChevronLeft size={isMobile ? 18 : 20} />
//         </button>

//         {/* Numbers */}
//         <div className="flex items-center gap-1">
//           {getPageNumbers().map((page, index) => (
//             <React.Fragment key={index}>
//               {page === '...' ? (
//                 <span className="w-6 text-center text-gray-400 text-[10px] font-bold tracking-tighter">
//                   ...
//                 </span>
//               ) : (
//                 <button
//                   onClick={() => onPageChange(page)}
//                   className={`py-1.5 sm:py-2 px-1 min-w-[30px] sm:min-w-[36px]  flex items-center justify-center rounded-lg text-[11px] sm:text-xs font-bold transition-all duration-300 ${
//                     currentPage === page
//                       ? 'bg-blue-600 text-white shadow-lg shadow-blue-200 scale-110 z-10'
//                       : 'text-gray-500 hover:bg-gray-100'
//                   }`}
//                 >
//                   {page}
//                 </button>
//               )}
//             </React.Fragment>
//           ))}
//         </div>

//         {/* Next Button */}
//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="p-2 rounded-xl text-gray-400 hover:bg-gray-100 disabled:opacity-20 transition-all active:scale-90 flex-shrink-0"
//         >
//           <ChevronRight size={isMobile ? 18 : 20} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Pagination;

// import React, { useState, useEffect } from "react";

import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  // if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) pages.push(i);

      if (currentPage < totalPages - 2) pages.push("...");

      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div className="w-full flex justify-center sm:justify-between items-center gap-3 select-none">
      
      {/* LEFT – Previous (Desktop only) */}
      {/* {!isMobile && ( */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg border text-xs font-medium
          text-gray-600 hover:bg-gray-100 disabled:opacity-30"
        >
          <ChevronLeft size={16} />         
          <span className="hidden md:block">Previous</span>
          
        </button>
      {/* )} */}

      {/* PAGE NUMBERS */}
      <div className="flex items-center gap-1">
        {getPageNumbers().map((page, i) =>
          page === "..." ? (
            <span
              key={i}
              className="px-2 text-gray-400 text-xs font-medium"
            >
              ...
            </span>
          ) : (
            <button
              key={i}
              onClick={() => {
                if (typeof page === "number") {
                  onPageChange(page);
                }
              }}

              className={`min-w-[32px] h-8 px-2 rounded-lg text-xs font-semibold transition-all
                ${
                  currentPage === page
                    ? "bg-blue-600 text-white shadow-md"
                    : "border text-gray-600 hover:bg-gray-100"
                }`}
            >
              {page}
            </button>
          )
        )}
      </div>

      {/* RIGHT – Next (Desktop only) */}
      {/* {!isMobile && ( */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg border text-xs font-medium
          text-gray-600 hover:bg-gray-100 disabled:opacity-30"
        >
          <span className="hidden md:block">Next</span>
          <ChevronRight size={16} />
        </button>
      {/* )} */}
    </div>
  );
};

export default Pagination;
